globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.GoogleMyBusiness = appCustomerSpace.Controllers.GoogleMyBusiness || {};

appCustomerSpace.Controllers.GoogleMyBusiness.RegularHoursController = (function(superClass) {

  utils.extend(RegularHoursController, superClass);

  function RegularHoursController() {
    this.$form = $('form.regular-hours-form');

    return RegularHoursController.__super__.constructor.apply(this, arguments);
  }

  $.extend(RegularHoursController.prototype, {
    init: function(){
      this.initEvents();

      return RegularHoursController.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      // Open/Close checkbox
      this.$form.on('change', '.open-state .switchery', function(){
        var $checkbox            = $(this),
            $regularHoursForm    = $checkbox.closest('.regular-hours-form'),
            $formGroup           = $checkbox.closest('.form-group'),
            $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
            $openLabel           = $formGroup.find('.open-label'),
            $closeLabel          = $formGroup.find('.close-label'),
            $dayLabel            = $formGroup.find('.day-label'),
            $inputOpenTime       = $formGroup.find('input.input-open-time'),
            $inputCloseTime      = $formGroup.find('input.input-close-time');

        if($checkbox.is(':checked')) {
          $openLabel.show();
          $closeLabel.hide();
          $dayLabel.removeClass('text-muted');
          $regularHoursWrapper.find('input.input-destroy').val(false).end().show();
          $regularHoursWrapper.find('.slot-hour-item').show();

          var dayIndex                 = parseInt($checkbox.closest('.hours-on-day').data("day-index")),
              $previousDayHoursContent = $regularHoursForm.find(`#hours-on-day-${dayIndex - 1}`),
              $previousOpenState       = $previousDayHoursContent.find('.open-state .switchery'),
              previousOpenTimeValue    = $previousDayHoursContent.find('.input-open-time').val(),
              previousCloseTimeValue   = $previousDayHoursContent.find('.input-close-time').val();

          if ($previousOpenState.is(':checked') && previousOpenTimeValue != "00:00") {
            if ($inputOpenTime.val() == "00:00") {
              $inputOpenTime.val(previousOpenTimeValue);
            }
            if ($inputCloseTime.val() == "00:00") {
              $inputCloseTime.val(previousCloseTimeValue);
            }
          } else {
            if ($inputOpenTime.val() == "00:00") {
              $inputOpenTime.val("09:00");
            }
            if ($inputCloseTime.val() == "00:00") {
              $inputCloseTime.val("18:00");
            }
          }
        } else {
          $openLabel.hide();
          $closeLabel.show();
          $dayLabel.addClass('text-muted');
          $regularHoursWrapper.find('input.input-destroy').val(true).end().hide();
        }
      });

      // COMMUN (remplacer 'special' par 'regular')
      // '24h/24' button on click event
      this.$form.on('click', '.day-all-day', function(e){
        e.preventDefault();
        var $button = $(this),
            $regularHoursWrapper = $button.closest('.regular-hours-wrapper'),
            $regularHourItemAllDay = $regularHoursWrapper.find('.regular-hour-item-all-day');

        if ($button.hasClass('active')) {
          $regularHourItemAllDay.find('input.input-destroy').val(true).end().hide();
          $regularHoursWrapper.find('.slot-hour-item').each(function(){
            $(this).find('input.input-destroy').val(false).end().show();

            $(this).find('.input-close-time-wrapper').prev().css("display", "flex").end().show();
            $(this).find('.input-close-time').prop('disabled', false);
            $(this).find('.input-close-time-wrapper').next().show();
            $(this).find('input.input-all-day').val(false);
            $(this).find('.open-time-hard-text').hide();
            $(this).find('.open-time-input-field').show();
          });
          $regularHoursWrapper.find('.day-add-regular-hour').show();

          $button.removeClass('active btn-primary');
          $button.addClass('btn-default');
          $button[0].dataset['originalTitle'] = "Apparaître ouvert 24h/24"

        } else {
          $regularHourItemAllDay.find('input.input-destroy').val(false).end().show();
          $regularHoursWrapper.find('.slot-hour-item').each(function(){
            $(this).find('input.input-destroy').val(true).end().hide();
          });
          $regularHoursWrapper.find('.day-add-regular-hour').hide();

          $button.addClass('active btn-primary');
          $button.removeClass('btn-default');
          $button[0].dataset['originalTitle'] = "Ne plus apparaître ouvert 24h/24"

        }
      });

      // COMMUN (remplacer 'special' par 'regular' et 'Special' par 'Regular')
      // Delete a timeslot
      this.$form.on('click', '.day-delete-hour', function(e){
        e.preventDefault();
        var $dayDeleteRegularHourButton = $(this),
            $regularHourItem = $dayDeleteRegularHourButton.closest('.slot-hour-item'),
            $formGroup = $dayDeleteRegularHourButton.closest('.form-group'),
            $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
            $checkbox = $formGroup.find('input[type=checkbox]'),
            $openLabel = $formGroup.find('.open-label'),
            $closeLabel = $formGroup.find('.close-label'),
            is_hidden = true;

        $regularHourItem.find('input.input-destroy').val(true).end().hide();

        // if no more timeslot -> switchery should be unchecked
        $regularHoursWrapper.find('.slot-hour-item').each(function(){
          if (!$(this).is(':hidden')) {
            is_hidden = false;
          }
        });
        if (is_hidden) {
            $openLabel.hide();
            $closeLabel.show();
            $checkbox.click();
        }
      });

      // COMMUN (remplacer 'special' par 'regular')
      // Add a timeslot (ajax)
      this.$form.on('click', '.day-add-regular-hour', function(e){
        e.preventDefault();
        var $dayAddRegularHour = $(this),
            $formGroup = $dayAddRegularHour.closest('.form-group'),
            $regularHoursWrapper = $formGroup.find('.regular-hours-wrapper'),
            url = $dayAddRegularHour.data("url");

        $.ajax({
          type: "POST",
          url: url,
          success: function(data)
          {
            if (data.response == 1) {
              if (data.views !== undefined && data.views.regularHourThumbnail !== undefined) {
                $regularHoursWrapper.append($(data.views.regularHourThumbnail));
                $regularHoursWrapper.find('.slot-hour-item').find('input.input-destroy').val(false);
              }
            } else {
              $.each(data.errors, function(key, value) {
                var $error = $('<p class="error">' + value[0] + '</p>');
                $error.prependTo($dayAddRegularHour);
              });
            };
          }
        });
      });
    }
  });

  return RegularHoursController;

})(appCustomerSpace.Controllers.GoogleMyBusiness.MainController);
